import { render, staticRenderFns } from "./solarterm.vue?vue&type=template&id=3f8b6141"
import script from "./solarterm.vue?vue&type=script&lang=js"
export * from "./solarterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports